<!--  -->
<template>
  <div>
    <el-form
      v-loading="loading"
      :label-position="labelPosition"
      label-width="110px"
      element-loading-text="正在生成获客地址..."
      element-loading-spinner="el-icon-loading"
    >
      <el-form-item label="企业">
        <el-tag v-if="corp_id!=''" style="margin-right:10px">{{ name }} ({{ corp_id }}) </el-tag>
        <el-button type="primary" size="mini" @click="choose">选择企业</el-button>
      </el-form-item>
      <el-form-item label="企业员工">
        <el-tag v-for="items,index in corp_userid" :key="index" style="margin-right:10px" closable @close="handleClose(index)">{{ items.name }} </el-tag>
        <el-button type="primary" size="mini" :disabled="corp_id==''" @click="chorwe">选择企业员工</el-button>
      </el-form-item>
      <el-form-item label="链接名称">
        <el-input v-model="link_name" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumnbior">点击生成</el-button>
      </el-form-item>
      <el-form-item label="生成的获客地址">
        <el-tag v-if="link!=''" type="warning">{{ link }}</el-tag>
        <i
          v-if="link!=''"
          v-clipboard:copy="link"
          v-clipboard:success="cowe"
          v-clipboard:error="onError"
          style="margin-left: 5px;color: #E6A23C;cursor: pointer;"
          class="el-icon-document-copy"
        />
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择企业"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <enterprise @callback="callback" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff_userid ref="bandstaffuseridview" @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
import bandstaff_userid from './bandstaff_userid.vue'
import enterprise from '../../behavioralsource/components/enterprise.vue'
import { spCorpspCustomerAcquisition } from '@/api/ladderdiagram.js'
export default {
  components: { bandstaff_userid, enterprise },
  data() {
    return {
      labelPosition: 'right',
      dialogVisibler: false,
      dialogVisible: false,
      corp_userid: [],
      corp_id: '',
      name: '',
      link_name: '',
      link: '',
      loading: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffuseridview.sendr(this.corp_id, this.corp_userid)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.corp_userid = arr
      console.log(arr)
    },
    handleClose(index) {
      this.corp_userid.splice(index, 1)
    },
    choose() {
      this.dialogVisible = true
    },
    callback(item) {
      this.dialogVisible = false
      this.name = item.corp_name
      this.corp_id = item.corp_id
      this.corp_userid = []
    },
    sumnbior() {
      // eslint-disable-next-line eqeqeq
      if (this.corp_id == '') {
        this.$message.error('请选择企业')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.corp_userid.length == 0) {
        this.$message.error('请选择企业人员')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.link_name == '') {
        this.$message.error('请输入链接名称')
        return
      }
      this.loading = true
      const userIds = this.corp_userid.map(item => item.user_id)
      spCorpspCustomerAcquisition({
        corp_id: this.corp_id,
        link_name: this.link_name,
        skip_verify: true,
        range: { user_list: userIds }
      }).then((res) => {
        console.log('res', res)
        this.link = res.data.link.url
        this.loading = false
      })
        .catch((err) => {
          console.error('接口错误', err)
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    cowe() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onError() {
      this.$message({
        message: '复制失败',
        type: 'error'
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
